import * as React from "react";
import AgGridTableBaseTooltip, { AgGridTableBaseTooltipProps } from "../AgGridTableBaseTooltip";

export default function AgGridTableStandardTooltip(props: AgGridTableBaseTooltipProps) {
    const { rowIndex, colDef } = props;
    const { api, value, selectionAxisColumnId } = props;
    const row = api.getDisplayedRowAtIndex(rowIndex);
    const data = row && row.data;
    return ( 
        <AgGridTableBaseTooltip {...props}> 
        {data &&
            <>
                <p><b>{colDef.headerTooltip}</b></p>
                <p><b>{data && data[selectionAxisColumnId]}</b>: {value}</p>
            </>
        }
        </AgGridTableBaseTooltip>
    );
}